import { FragmentListItemDto } from '@app/modules/fragments/fragment.types';
import { DurationForRange } from '@mi-front/ui';
import { FragmentMediaPill } from './FragmentMediaPill';

/**
 * Pill showing fragment duration (from–to). Used as overlay on audio/video card media.
 */
export function FragmentCardDurationPill({ fragment }: { fragment: FragmentListItemDto }) {
  return (
    <FragmentMediaPill>
      <DurationForRange from={fragment.from} to={fragment.to} unitDisplay="narrow" />
    </FragmentMediaPill>
  );
}
